import { deleteCookie, getCookie, setCookie } from 'cookies-next';

import { Cart, CartLineItem } from 'types/cart';

const CART_COOKIE_NAME = 'ggCart';
const CART_COOKIE_MAX_AGE = 7 * 24 * 60 * 60; // 7 days

const DEFAULT_CART: Cart = {
  orderToken: null,
  lineItems: [],
};

export const getCartFromCookie = (): Cart => {
  let cartData = DEFAULT_CART;

  try {
    const cartCookie = getCookie(CART_COOKIE_NAME);

    if (cartCookie && typeof cartCookie === 'string') {
      const parsedCart = JSON.parse(cartCookie);

      // Validate the cart structure
      if (
        parsedCart &&
        typeof parsedCart === 'object' &&
        Array.isArray(parsedCart.lineItems)
      ) {
        cartData = {
          orderToken: parsedCart.orderToken || null,
          lineItems: parsedCart.lineItems.filter(
            (item: CartLineItem) =>
              item &&
              typeof item.catalogItemToken === 'string' &&
              item.catalogItemToken.length > 0 &&
              typeof item.quantity === 'number' &&
              item.quantity > 0,
          ),
        };
      }
    }
  } catch (e) {
    // If parsing fails, return default cart
    console.warn('Failed to parse cart cookie:', e);
  }

  return cartData;
};

export const setCartCookie = (cart: Cart) => {
  setCookie(CART_COOKIE_NAME, JSON.stringify(cart), {
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
    maxAge: CART_COOKIE_MAX_AGE,
  });
};

export const clearCartCookie = () => {
  deleteCookie(CART_COOKIE_NAME, {
    path: '/',
  });
};
